export const routes = [
  { path: '/news', name: 'NewsList', component: () => import('@/app/modules/news/views/NewsList.vue') },
  {
    path: '/news/item/:id',
    name: 'NewsItem',
    component: () => import('@/app/modules/news/views/NewsItem.vue'),
  },
];
